<template>
	<span
		role="status"
		class="inline-block animate-pulse rounded bg-gray-100 dark:bg-gray-600"
	>
		&nbsp;

		<span class="sr-only">Loading...</span>
	</span>
</template>

<script setup lang="ts"></script>
